import React, { FunctionComponent } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { IProps } from './IProps'
import style from './style.scss'

export const LabelWithIcon: FunctionComponent<IProps> = ({
    icon,
    labelText,
}) => {
    return (
        <div
            className={style.labelWithIconWrapper}
            onClick={() => console.log(labelText, icon)}
        >
            <FontAwesomeIcon icon={icon} className={style.faIcon} />
            <p> {labelText} </p>
        </div>
    )
}
